var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#9FA7D1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.167c-2.527 0-4.583-2.055-4.583-4.583C3.667 2.057 5.723 0 8.25 0s4.583 2.056 4.583 4.583-2.056 4.584-4.583 4.584z",
    transform: "translate(-784 -7147) translate(0 6947) translate(784 200)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.355.014C1.952.014 0 1.967 0 4.37v3.208c0 .375.312.687.688.687h8.48v-2.98c0-1.722 1.282-3.144 2.942-3.391.238-.698.687-1.283 1.265-1.705-.918-.262-.967-.174-9.02-.174z",
    transform: "translate(-784 -7147) translate(0 6947) translate(784 200) translate(0 10.986)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.355.029C5.952.029 4 1.98 4 4.383v3.208c0 .375.312.688.688.688h8.48v-2.98c0-1.723 1.282-3.145 2.942-3.392.238-.697.687-1.283 1.265-1.705-.918-.261-.967-.173-9.02-.173z",
    transform: "translate(-784 -7147) translate(0 6947) translate(784 200) translate(0 10.986) matrix(-1 0 0 1 21.375 0)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.48cce8af179d57398c6a2c09ca522384.svg";
export { ForwardRef as ReactComponent };